import {PublisherData} from './AdminDashboardByPublisher';
import ReactEcharts from 'echarts-for-react';

interface Props {
    pubDat: PublisherData[],
    style: {}
}

const PieChartByPublisher = (props: Props) => {
    const data = props.pubDat.map(d => {
        return {value: d.revenue, name: d.name}
    })

    const labelData = props.pubDat.map(d => d.name)

    const option = {
        title: {
            text: 'Revenue',
            subtext: 'by Publisher',
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: labelData
        },
        series: [
            {
                type: 'pie',
                radius: '50%',
                center: ['40%', '50%'],
                label: {
                    formatter: '{b}\n{c}\n({d}%)',
                    edgeDistance: 10
                },
                data: data,
            }
        ]
    }

    return <ReactEcharts style={props.style} option={option}/>
}

export default PieChartByPublisher
